import type { ProjectReportRecord } from '@/types/project-report';
import { formatDate } from '@/utils/format-date';

interface MobileTopLeaderProjectProgressCardProps {
  report: ProjectReportRecord;
  onClick?: () => void;
}

function excerpt(text: string | null | undefined, maxLen = 80): string {
  const value = text?.trim() ?? '';
  if (!value) {
    return '—';
  }
  return value.length > maxLen ? `${value.slice(0, maxLen)}…` : value;
}

export function MobileTopLeaderProjectProgressCard({
  report,
  onClick,
}: MobileTopLeaderProjectProgressCardProps) {
  return (
    <button
      type="button"
      className="mobile-card mobile-card--clickable mobile-progress-card"
      onClick={onClick}
    >
      <div className="mobile-progress-card__head">
        <span className="mobile-progress-card__project">{report.project.name}</span>
        <span className="mobile-progress-card__date">{formatDate(report.reportDate)}</span>
      </div>
      <div className="mobile-progress-card__meta">
        汇报人 {report.createdBy.name}
      </div>
      <div className="mobile-progress-card__field">
        <span className="mobile-progress-card__label">项目进展</span>
        <p className="mobile-progress-card__text">{excerpt(report.progressContent)}</p>
      </div>
      <div className="mobile-progress-card__field">
        <span className="mobile-progress-card__label">问题与风险</span>
        <p className="mobile-progress-card__text">{excerpt(report.problemContent)}</p>
      </div>
      <div className="mobile-progress-card__field">
        <span className="mobile-progress-card__label">下一步计划</span>
        <p className="mobile-progress-card__text">{excerpt(report.nextPlanContent)}</p>
      </div>
    </button>
  );
}
